import { AudioChunk } from './AudioChunk'
import { AudioBufferChunk } from './AudioBufferChunk'

export class CutterAudio {
  readonly length: number
  readonly numberOfChannels: number
  readonly chunks: AudioChunk[]

  constructor(audioBuffer: AudioBuffer) {
    this.length = audioBuffer.length
    this.numberOfChannels = audioBuffer.numberOfChannels

    this.chunks = [
      new AudioBufferChunk({
        start: 0,
        end: audioBuffer.length,
        offset: 0,
      }),
    ]
  }
}
